<template>
  <div style="height: 100%">
    <el-container>
      <el-header height="48px">
        <div class="left">
          <img src="@/assets/img/layout-logo.png" alt="" />
          <div class="line"></div>
          <p>内部数据运营平台</p>
        </div>
        <div class="right">
          <img src="@/assets/img/layout-user.png" alt="" />
          <p>{{ userInfo.RealName }}</p>
          <div class="close" @click="close">
            <img src="@/assets/img/layout-close.png" alt="" />
            <span>注销</span>
          </div>
        </div>
      </el-header>
      <el-container>
        <layoutMenu />
        <el-container>
          <el-main>
            <!-- <div class="bread">
              <el-breadcrumb separator="/">
                <el-breadcrumb-item
                  :to="{ path: item.path }"
                  v-for="(item, index) in NavList"
                  :key="index"
                  >{{ item.title }}</el-breadcrumb-item
                >
              </el-breadcrumb>
            </div> -->
            <el-page-header
              class="title"
              v-if="isBack"
              @back="goBack"
              :content="$store.state.schoolName?title+'('+$store.state.schoolName+')':title"
            ></el-page-header>
            <div class="title" v-else>{{ title }}</div>
            <transition name="el-fade-in">
              <keep-alive :include="list" :max="10">
                <router-view />
              </keep-alive>
            </transition>
            <a href="https://beian.miit.gov.cn" target="_blank" class="footer" v-text="
            ' Copyright © ' + new Date().getFullYear() +
            ' Beijing HexFuture Technology Co., Ltd. All Rights Reserved 京ICP备16054026号-1'"></a>
          </el-main>
        </el-container>
      </el-container>
    </el-container>
  </div>
</template>

<script>
import layoutMenu from "@/components/layout/menu";
import { routers } from "@/utils/keepAliveRoute.js";
export default {
  name: "Layout",
  components: {
    layoutMenu,
  },
  data() {
    return {
      userInfo: JSON.parse(sessionStorage.getItem("userInfo")),
      list: routers,
    };
  },
  watch: {
    $route: {
      handler() {
        this.getNavList();
      },
      immediate: true,
    },
  },
  created() {},
  mounted() {},
  computed: {
    key() {
      return this.$route.path;
    },
    title() {
      return this.$store.state.title;
    },
    isBack() {
      return this.$store.state.isBack;
    },
  },
  methods: {
    close() {
      sessionStorage.removeItem("userInfo");
      sessionStorage.removeItem("schoolList");
      sessionStorage.removeItem("cityList");
      this.$router.push("/login");
    },
    getNavList() {
      let list = this.$route.matched.filter((item) => item.name);
      let arr = [];
      list.forEach((el, index) => {
        if (index > 0) {
          arr = arr.concat(el.meta.title.split("/"));
        }
      });
      let title = "";
      if (arr.length > 1) {
        arr.forEach(el => title+=el+'/')
        title = title.substr(0, title.length - 1)
      } else {
        title = arr[arr.length - 1];
      }
      this.$store.commit("SET_TITLE", title);
    },
    goBack() {
      this.$router.go(-1);
    },
  },
};
</script>

<style lang="scss" scoped>
.el-container {
  height: 100%;
}
.el-header {
  background-color: #48618b;
  color: #fff;
  line-height: 48px;
  display: flex;
  justify-content: space-between;
  .left {
    height: 100%;
    display: flex;
    align-items: center;
    img {
      width: 86px;
      height: 20px;
    }
    .line {
      width: 1px;
      height: 18px;
      background-color: #fff;
      margin: 0 15px;
    }
  }
  .right {
    height: 100%;
    display: flex;
    align-items: center;
    font-size: 14px;
    img {
      width: 24px;
      height: 24px;
    }
    p {
      margin: 0 24px 0 8px;
    }
    .close {
      width: 64px;
      height: 24px;
      background: rgba(255, 255, 255, 0.1);
      border-radius: 12px;
      border: 1px solid rgba(255, 255, 255, 0.4);
      line-height: 21px;
      cursor: pointer;
      img {
        width: 14px;
        height: 14px;
        vertical-align: middle;
        margin: -1.5px 5px 0 7px;
      }
    }
  }
}

.el-aside {
  background-color: #d3dce6;
  color: #333;
  line-height: 200px;
}

.el-main {
  background-color: #f6f8fc;
  overflow: hidden;
  height: calc(100vh - 48px);
  position: relative;
  .bread {
    margin-top: -8px;
  }
  .title {
    height: 28px;
    color: #101f38;
    line-height: 28px;
    margin-top: 0px;
    font-weight: 500;
    margin-bottom: 16px;
    font-size: 20px;
    ::v-deep .el-page-header__content {
      font-size: 20px;
    }
  }
  .footer{
    width: fit-content;
    display: block;
    left: 50%;
    margin-left: -268px;
    position: absolute;
    bottom: 5px;
    font-size: 12px;
    text-align: center;
    color: #717994;
  }
}
</style>
